import { createContext } from 'react';
import { DEFAULT_THEME_NAME } from '../constants.js';

const ChartContext = /*#__PURE__*/createContext({
  id: null,
  characterWidths: {},
  characterWidthOffsets: {
    fontSize: {},
    fontWeight: {}
  },
  containerBounds: {
    height: 0,
    width: 0,
    x: 0,
    y: 0
  },
  shouldAnimate: true,
  theme: DEFAULT_THEME_NAME,
  isTouchDevice: false,
  isPerformanceImpacted: false,
  comparisonIndexes: [],
  comparisonSeriesIndexes: []
});

export { ChartContext };
